import React from "react"
import { Link } from "gatsby"
import { Box, Flex, Heading, Image } from "components"
import { motion } from "framer-motion"
import css from "@styled-system/css"

function PreviewCard({ bottomSpace, topSpace, location, project }) {
  return (
    <>
      <Flex
        data-component-id="titleCard"
        flexDirection="column"
        justifyContent="flex-end"
        minWidth="50vw"
        minHeight={[`calc(var(--vh, 1vh) * 50)`, null, 0]}
        py={["layout.2", "layout.4", 0]}
        px={["layout.2", "layout.4"]}
      >
        <motion.div
          variants={{
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                delay:
                  location.search.indexOf("?scroll=") !== -1 ||
                  location.search.indexOf("?topScroll=") !== -1
                    ? 0
                    : 0.66,
                duration:
                  location.search.indexOf("?scroll=") !== -1 ||
                  location.search.indexOf("?topScroll=") !== -1
                    ? 0
                    : 1.4,
                ease: [0.215, 0.61, 0.355, 1],
              },
            },
            initial: {
              opacity: 0,
              y: 40,
              transition: {
                when: "afterChildren",
              },
            },
          }}
          initial="initial"
          animate="visible"
          key={"preview" + project.title + "meta"}
        >
          <Heading size={900} mt={["layout.2", "layout.4"]}>
            <Box
              as={Link}
              to={"/project/" + project.uid + "/?mobile=true"}
              display="block"
            >
              Next up: {project.title}
            </Box>
            <Box as="span" display="block" fontFamily="serif" fontWeight={300}>
              {project.category}
            </Box>
          </Heading>
        </motion.div>
      </Flex>
      {project.gallery && project.gallery[0] && (
        <Box
          data-component-id="🖼"
          position="relative"
          minWidth={[
            "100%",
            null,
            `calc(${(project.gallery[0].photo.dimensions.width /
              project.gallery[0].photo.dimensions.height) *
              100}vh - ${topSpace} - ${bottomSpace})`,
          ]}
          height={[
            `calc(${(project.gallery[0].photo.dimensions.height /
              project.gallery[0].photo.dimensions.width) *
              50}vw)`,
            null,
            `calc(100vh - ${topSpace} - ${bottomSpace})`,
          ]}
          key={"previewImage" + project.gallery[0].photo.url}
          css={css({ overflow: "hidden" })}
        >
          <Box
            as={Link}
            to={"/project/" + project.uid + "/?mobile=true"}
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height={`calc(${(project.gallery[0].photo.dimensions.height /
              project.gallery[0].photo.dimensions.width) *
              100}vw)`}
            bg="text"
          >
            <Image
              image={{
                url: project.gallery[0].photo.url + "&fit=fill&w=2000",
                dimensions: project.gallery[0].photo.dimensions,
                twoThirds: {
                  url: project.gallery[0].photo.url + "&fit=fill&w=1600",
                  dimensions: {
                    height: project.gallery[0].photo.dimensions.height / 5,
                    width: project.gallery[0].photo.dimensions.width / 5,
                  },
                },
                placeholder: {
                  url: project.gallery[0].photo.url + "&fit=fill&w=600",
                  dimensions: {
                    height: project.gallery[0].photo.dimensions.height / 10,
                    width: project.gallery[0].photo.dimensions.width / 10,
                  },
                },
              }}
              sizes="1024px"
              style={{ height: "100%", objectPosition: "center top" }}
            />
          </Box>
        </Box>
      )}
    </>
  )
}

export default PreviewCard
